import React, { Fragment } from "react";
import styled from "styled-components";

export function LanguageBar({
  languages,
  handleSelect,
  selectedLanguage,
  ...props
}) {
  return (
    <Container {...props}>
      {languages.map(({ name, value }) => (
        <Fragment key={value}>
          <Lang
            onClick={() => handleSelect(value)}
            selected={value === selectedLanguage}
          >
            {name}
          </Lang>
          <Divider />
        </Fragment>
      ))}
    </Container>
  );
}

const Container = styled.div`
  direction: ltr;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  row-gap: 8px;
  column-gap: 16px;
  padding-block: 8px;
`;

const Lang = styled.button`
  font-family: inherit;
  outline: none;
  border: none;
  cursor: pointer;
  padding-inline: 0rem;
  color: ${({ selected }) => (selected ? "#84A4FC" : "black")};
  background-color: transparent;
  font-size: 1.1rem;
`;

const Divider = styled.div`
  height: 1rem;
  width: 1px;
  background-color: #54472b;
  opacity: 0.1;
  &:last-of-type {
    display: none;
  }
`;
